import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { FormContext } from '../context/FormContext';
/**
 * @returns {import('./types').EcrionFormLayout}
 */

var useFormLayout = function useFormLayout() {
  var _React$useContext = React.useContext(FormContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 1),
      state = _React$useContext2[0];

  return state.layout;
};

export default useFormLayout;